import ComprasDiretasAbertas from '@/views/pages/fornecedor/compras-diretas-abertas/ComprasDiretasAbertas'
import ComprasDiretasEncerradasFornecedor from '@/views/pages/fornecedor/compras-diretas-encerradas/ComprasDiretasEncerradas'
import MinhasComprasDiretasFornecedor from '@/views/pages/fornecedor/minhas-compras-diretas/MinhasComprasDiretas'
import DetalhesCompraDireta from '@/views/pages/fornecedor/detalhes-compra-direta/DetalhesCompraDireta'
import EtapasParticipacao from '@/views/pages/fornecedor/etapas-participacao/EtapasParticipacao'
import TermoDoFornecedor from '@/views/pages/fornecedor/etapas-participacao/termo/Termo'
import PropostaDoFornecedor from '@/views/pages/fornecedor/etapas-participacao/proposta/Proposta'
import LanceDoFornecedor from '@/views/pages/fornecedor/etapas-participacao/lance/Lance'
import ProtocoloDoFornecedor from '@/views/pages/fornecedor/etapas-participacao/protocolo/Protocolo'
import ResultadoDoFornecedor from '@/views/pages/fornecedor/resultado/Resultado'
import DocumentoPropostaDoFornecedor from '@/views/pages/fornecedor/resultado/documento-proposta/DocumentoProposta'
import ResultadoFinalDoFornecedor from '@/views/pages/fornecedor/resultado/resultado-final/ResultadoFinal'
import MensagemEncerramento from '@/views/pages/fornecedor/etapas-participacao/mensagem-encerramento/MensagemEncerramento'
import ManualCompraDiretaFornecedor from '@/views/pages/fornecedor/manual-do-fornecedor/ManualCompraDiretaFornecedor'
import CompraDiretaNaoPublicada from '@/views/pages/fornecedor/erro/compraNaoPublicada'
import LanceDesempate from '@/views/pages/fornecedor/resultado/lance-desempate/LanceDesempate'

const fornecedorNormalAuth = 'Fornecedor.Normal'

export default [
    {
        path: '/fornecedor/abertas',
        name: 'ComprasDiretasAbertas',
        component: ComprasDiretasAbertas,
        meta: {
            menu: {
                title: 'Abertas',
                icon: 'fas fa-tags'
            },
            page: {
                title: 'Compras Diretas Eletrônicas',
                subtitle: 'Lista geral de compras diretas eletrônicas'
            },
            requiresAuth: true,
            authorities: [fornecedorNormalAuth]
        }
    },
    {
        path: '/fornecedor/minhas',
        name: 'MinhasComprasDiretas',
        component: MinhasComprasDiretasFornecedor,
        meta: {
            menu: {
                title: 'Minhas Compras',
                icon: 'fas fa-file-alt'
            },
            page: {
                title: 'Minhas Compras Diretas',
                subtitle: 'Lista de minhas compras diretas eletrônicas'
            },
            requiresAuth: true,
            authorities: [fornecedorNormalAuth]
        }
    },
    {
        path: '/fornecedor/encerradas',
        name: 'ComprasDiretasEncerradasDoFornecedor',
        component: ComprasDiretasEncerradasFornecedor,
        meta: {
            menu: {
                title: 'Encerradas',
                icon: 'fas fa-check-square'
            },
            page: {
                title: 'Compras Diretas Encerradas',
                subtitle: 'Lista de compras diretas eletrônicas encerradas'
            },
            requiresAuth: true,
            authorities: [fornecedorNormalAuth]
        }
    },
    {
        path: '/manualFornecedor',
        name: 'ManualCompraDiretaFornecedor',
        component: ManualCompraDiretaFornecedor,
        meta: {
            menu: {
                title: 'Manual',
                icon: 'fas fa-lightbulb'
            },
            page: {
                title: 'Manual do Compra Direta',
                subtitle: 'Manual do fornecedor'
            },
            requiresAuth: true,
            authorities: [fornecedorNormalAuth]
        }
    },
    {
        path: '/fornecedor/detalhes/:id',
        name: 'DetalhesCompraDireta',
        component: DetalhesCompraDireta,
        meta: {
            page: {
                title: 'Compra Direta',
                subtitle: 'Detalhes da compra direta'
            },
            scrollToTop: true,
            requiresAuth: true,
            authorities: [fornecedorNormalAuth]
        }
    },
    {
        path: '/fornecedor/compra-direta/:id/proposta/:propostaId',
        name: 'EtapasParticipacao',
        component: EtapasParticipacao,
        children: [
            {
                path: 'termo',
                name: 'TermoDoFornecedor',
                component: TermoDoFornecedor,
                meta: {
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: [fornecedorNormalAuth]
                }
            },
            {
                path: 'proposta-inicial',
                name: 'PropostaDoFornecedor',
                component: PropostaDoFornecedor,
                meta: {
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: [fornecedorNormalAuth]
                }
            },
            {
                path: 'lance',
                name: 'LanceDoFornecedor',
                component: LanceDoFornecedor,
                meta: {
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: [fornecedorNormalAuth]
                }
            },
            {
                path: 'protocolo',
                name: 'ProtocoloDoFornecedor',
                component: ProtocoloDoFornecedor,
                meta: {
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: [fornecedorNormalAuth]
                }
            },
            {
                path: 'lance-desempate',
                name: 'LanceDesempate',
                component: LanceDesempate,
                meta: {
                    page: {
                        title: 'Compra Direta',
                        subtitle: 'Lance de Desempate'
                    },
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: [fornecedorNormalAuth]
                }
            },
            {
                path: 'mensagem-encerramento',
                name: 'MensagemEncerramento',
                component: MensagemEncerramento,
                meta: {
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: [fornecedorNormalAuth]
                }
            }
        ]
    },
    {
        path: '/fornecedor/compra-direta/:id/resultado/:propostaId?',
        name: 'ResultadoDoFornecedor',
        component: ResultadoDoFornecedor,
        children: [
            {
                path: 'documento-proposta',
                name: 'DocumentoPropostaDoFornecedor',
                component: DocumentoPropostaDoFornecedor,
                meta: {
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: [fornecedorNormalAuth]
                }
            },
            {
                path: 'resultado-final',
                name: 'ResultadoFinalDoFornecedor',
                component: ResultadoFinalDoFornecedor,
                meta: {
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: [fornecedorNormalAuth]
                }
            }
        ]
    },
    {
        path: '/fornecedor/erros/compra-direta',
        name: 'CompraDiretaErro',
        component: CompraDiretaNaoPublicada,
        meta: {
            page: {
                title: 'Compra Direta',
                subtitle: 'Detalhes da compra direta'
            },
            scrollToTop: true,
            requiresAuth: true,
            authorities: [fornecedorNormalAuth]
        }
    }
]
